import { render, staticRenderFns } from "./AICustomerService.vue?vue&type=template&id=355c66dc&scoped=true"
import script from "./AICustomerService.vue?vue&type=script&lang=js"
export * from "./AICustomerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c66dc",
  null
  
)

export default component.exports